
export const servicos = [
  {
    nome: 'Api Admin',
    url: `https://api-na-palma-adm.sebrae.com.br/actuator/health`,
    parceiro: 'Sebrae',
    menu: 'Global',
  },
  {
    nome: 'Api Admin Homologação (Somente com VPN)',
    url: `https://na-palma-adm-backend.homologacao.sebrae.com.br/actuator/health`,
    parceiro: 'Sebrae',
    menu: 'Global',
  },
  {
    nome: 'Api APP',
    url: `https://api-app.sebrae.com.br/actuator/health`,
    parceiro: 'Sebrae',
    menu: 'Global',
  },
  // {
  //   nome: 'DataLake',
  //   url: `datalake/health`,
  //   parceiro: 'Sebrae PR',
  //   menu: 'Pra sua empresa',
  // },
  //
  // {
  //   nome: 'Na conta',
  //   url: 'naconta/health',
  //   parceiro: 'Sebrae',
  //   menu: 'Pra você',
  // },
  // {
  //   nome: 'CPE',
    //   url: '/empreendedores/health',
  //   parceiro: 'Sebrae NA',
  //   menu: 'Global',
  // },
  // {
  //   nome: 'Bind',
  //   url: 'https://api-na-palma-adm.sebrae.com.br/actuator/health/binds',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  {
    nome: 'Via Apia',
    url: 'https://api-na-palma-adm.sebrae.com.br/v1/via-appia/health',
    parceiro: 'Via Apia ',
    menu: 'Global',
    onlyAuth: true,
  },
  // {
  //   nome: 'SAS',
  //   url: '/sas/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'SIAC',
  //   url: '',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Fale Com o Especialista',
  //   url: '',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Mural',
  //   url: '',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Datahub',
  //   url: '/datahub/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'ChatBot',
  //   url: '/chatbot/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Blue',
  //   url: '/blue/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Radar Sebrae',
  //   url: '/radarsebrae/integracao/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Storage',
  //   url: '/storage/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'SEF',
  //   url: '',
  //   parceiro: 'SEF ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Evolutto',
  //   url: '/evolutto/health',
  //   parceiro: 'Evolutto ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Boletos',
  //   url: '/boletosdas/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'Fluxo de Caixa',
  //   url: '/integracao/fluxocaixa/categorias/lancamentos/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
  // {
  //   nome: 'CRM PR - SGO',
  //   url: '/sgopagamentos/health',
  //   parceiro: 'Sebrae ',
  //   menu: 'Pra sua empresa',
  // },
].sort((a, b) => {
  if (a.nome < b.nome)
    return -1;
  
  if (a.nome > b.nome)
    return 1;
  
  return 0;
  
})
